import useBranchId from "@/shared/hooks/useBranchId";
import { allDeliveryMethods, allSources } from "@/shared/utils/constant";
import { Branch } from "@/shared/utils/interfaces";

export const orderStatuses = [1, 2, 3, 4, 5, 7, 8, 9];

export const getQueryKey = (
  branch: number,
  sources = [],
  deliveryMethods = [],
  order_statuses = orderStatuses
) => {
  return [
    "v2",
    "orders_live",
    branch,
    order_statuses,
    ...sources,
    ...deliveryMethods,
  ];
};

const useOrdersQueryKey = (
  order_statuses = orderStatuses,
  localBranch?: Branch
) => {
  const branchId = useBranchId();
  const branch = localBranch?.id ?? branchId;
  const queryKey = getQueryKey(
    branch,
    allSources,
    allDeliveryMethods,
    order_statuses
  );

  return { queryKey, branch };
};

export default useOrdersQueryKey;
